<template>
  <div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
        v-if="promisedPayments"
        :items="promisedPayments"
        :fields="promisedPaymentsFields"
        @ClickOnDeleteButton="ClickOnDeleteButton"
        @ClickOnEditButton="editItem"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"
        isDelete="true"
        isEdit="true"/>
    <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    <editModal :editItem="selectedPaymentSetting"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  data () {
    return {
      promisedPaymentsFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'group_id',
          label: this.$i18n.t('Group'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('All') + '(0)'
            }
            for (let el of this.groups) {
              if (val === el.group_id) {
                return el.group_name + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'service_id',
          label: this.$i18n.t('Service'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('No')
            }
            for (let el of this.onceServices) {
              if (val === el.value) {
                return el.text + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'is_enabled', label: this.$i18n.t('Active'), sortable: true, formatter: (val, key, item) => { return val ? this.$t('Yes') : this.$t('No') }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedPaymentSetting: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  components: {
    editModal
  },
  methods: {
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to delete one of "Promised payments"?', this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_PROMISED_PAYMENTS_SETTINGS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_PROMISED_PAYMENTS_SETTINGS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    editItem (item) {
      this.selectedPaymentSetting = JSON.parse(JSON.stringify(item))
      this.selectedPaymentSetting.max_duration /= 86400
      this.selectedPaymentSetting.interval_duration /= 86400
      this.$root.$emit('bv::show::modal', 'modalEditPromisedPaymentSetting', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    showAdd () {
      this.selectedPaymentSetting = {
        flags: 0,
        free_balance: 0.0,
        group_id: -1,
        id: 0,
        interval_duration: 0,
        is_enabled: 0,
        last_payment_date: 0,
        max_duration: 0,
        max_value: 0.0,
        min_balance: 0.0,
        priority: 0,
        service_id: 0,
        use_free_balance: 0,
        use_min_balance: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditPromisedPaymentSetting', '#btnShow')
    }
  },
  computed: {
    promisedPayments () {
      return this.$store.getters['Settings/PROMISED_PAYMENTS_SETTINGS']
    },
    groups () {
      return this.$store.getters['Users/GROUPS']
    },
    onceServices () {
      let res = []
      for (let el of this.$store.getters['Tariffing/SERVICES']) {
        if (el.service_type !== 1) {
          continue
        }
        let newEl = {}
        newEl.value = el.service_id
        newEl.text = el.service_name
        res.push(newEl)
      }
      res.push({value: 0, text: this.$t('Empty')})
      return res
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_PROMISED_PAYMENTS_SETTINGS')
    this.$store.dispatch('Users/GET_GROUPS')
    this.$store.dispatch('Tariffing/GET_SERVICES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/promisedPayments/main.vue